import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { finalize } from "rxjs/operators";
import { ApiService } from "src/app/common/config/api.service";
import { User } from "src/app/common/config/app.classes";
import { FullSpinnerService } from "src/app/common/full-spinner/full-spinner.service";
import { DataService } from "src/app/common/services/data/data.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  user = new User();
  errorTrue = false;
  btnClicked = false;
  loadingTrue = false;
  errorTextShow = false;

  constructor(
    public data: DataService,
    public fullspinner: FullSpinnerService,
    public apiService: ApiService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void { }

  changeuserpassword(l) {
    // console.log(this.data.token);
    if (this.data.token !== "") {
      if (l.valid) {
        if (this.user.newPassword === this.user.confirmPassword) {
          this.errorTrue = false;
          this.btnClicked = true;
          this.fullspinner.empty.next(true);
          this.apiService
            .changeuserpassword(this.user)
            .pipe(
              finalize(() => {
                this.loadingTrue = false;
                this.btnClicked = false;
                this.fullspinner.empty.next(false);
              })
            )
            .subscribe((success: any) => {
              this.user = success;
              if (
                success.msg &&
                success.msg.infoMessage &&
                success.msg.infoMessage.msgDescription
              ) {
                this.data.successMessage(
                  success.msg.infoMessage.msgDescription
                );
              }
              this.onNoclick();
            });
        } else {
          this.errorTextShow = true;
        }
      } else {
        this.errorTrue = true;
      }
    } else {
      setTimeout(() => {
        this.changeuserpassword(l);
      }, 300);
    }
  }
  onNoclick() {
    this.dialog.closeAll();
  }
}
